import { CartService } from './../../services/cart/cart.service';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { CartConfigService } from '../../../cart/services/cart-config/cart-config.service';

@Component({
  selector: 'ags-cart-profile-button',
  templateUrl: './cart-profile-button.component.html',
  styleUrls: ['./cart-profile-button.component.scss']
})
export class CartProfileButtonComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() icon: string;
  @Input('waitLink')
  set _waitLink(value: boolean) {
    this.waitLink = value;
  }
  @Output() public outputLink = new EventEmitter<string>();
  waitLink: boolean;
  linkToCart: string;
  cartCount = 0;
  public isHovering: boolean;
  constructor(private cartConfigService: CartConfigService, private cartService: CartService) {}

  async ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.cartConfigService.themingClassName} exported`;
    this.linkToCart = `/${this.cartConfigService.routingBaseUri}`;
    if (this.waitLink) {
      this.outputLink.emit(this.linkToCart);
    }
    // le chargement de cartService est volontairement ralenti dans le constructor (cause: disponibilité de userConnected)
    // cartCount doit être placé à la fin pour l'affichage
    this.cartCount = this.cartService.getCartCount();
    this.cartService.resaListObservable().subscribe(list => {
      this.cartCount = list.length;
    });
  }
}
